import { PpaResponse } from '@afterpaytouch/portal-api'
import clsx from 'clsx'
import React, { FunctionComponent, useEffect } from 'react'
import { useTranslation } from '../../utils/convergence'
import styles from './style.module.css'

interface TruthInLendingIframeProps {
  documentData?: PpaResponse
  isTilDisclosure: boolean
  isApplePaylater?: boolean
  isInAppBrowser?: boolean
}

export const TruthInLendingIframe: FunctionComponent<TruthInLendingIframeProps> = ({
  documentData,
  isTilDisclosure,
  isApplePaylater = false,
  isInAppBrowser = false,
}) => {
  const { t } = useTranslation()

  useEffect(() => {
    const ppaIframe: HTMLIFrameElement | null = document.querySelector('#document-window')

    const scrollToTilDisclosure = (): void => {
      if (ppaIframe === null || ppaIframe.contentWindow === null) {
        return
      }
      ppaIframe.contentWindow.location.hash = 'truth-in-lending-disclosure'
    }

    if (isTilDisclosure) {
      ppaIframe?.addEventListener('load', scrollToTilDisclosure)
    }

    return () => {
      ppaIframe?.removeEventListener('load', scrollToTilDisclosure)
    }
  }, [isTilDisclosure])

  return (
    <iframe
      id='document-window'
      className={clsx(
        styles.documentIframe,
        isApplePaylater && styles.documentIframeApplePay,
        !isApplePaylater && isInAppBrowser && styles.documentIframeInApp
      )}
      srcDoc={documentData?.renderedHtml}
      title={t('common:iframeTitleTruthInLending')}
    ></iframe>
  )
}
